// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               unknown
// source: Protos/V1/Models/CreditModels.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import Long from "long";
import { Timestamp } from "../../../google/protobuf/timestamp";

export const protobufPackage = "daisi.protos.v1";

export interface CreditAccountInfo {
  AccountId: string;
  Balance: Long;
  TotalEarned: Long;
  TotalSpent: Long;
  TotalPurchased: Long;
  TokenEarnMultiplier: number;
  UptimeEarnMultiplier: number;
  DateCreated?: Date | undefined;
  DateLastUpdated?: Date | undefined;
}

export interface CreditTransactionInfo {
  Id: string;
  AccountId: string;
  Type: string;
  Amount: Long;
  Balance: Long;
  Description: string;
  RelatedEntityId: string;
  Multiplier: number;
  DateCreated?: Date | undefined;
}

export interface GetCreditAccountRequest {
  AccountId: string;
}

export interface GetCreditAccountResponse {
  Account?: CreditAccountInfo | undefined;
}

export interface GetCreditTransactionsRequest {
  AccountId: string;
  PageSize: number;
  PageIndex: number;
}

export interface GetCreditTransactionsResponse {
  Transactions: CreditTransactionInfo[];
  TotalCount: number;
}

export interface SetMultipliersRequest {
  AccountId: string;
  TokenEarnMultiplier?: number | undefined;
  UptimeEarnMultiplier?: number | undefined;
}

export interface SetMultipliersResponse {
  Account?: CreditAccountInfo | undefined;
}

export interface PurchaseCreditsRequest {
  AccountId: string;
  Amount: Long;
  Description: string;
}

export interface PurchaseCreditsResponse {
  Account?: CreditAccountInfo | undefined;
}

export interface AdjustCreditsRequest {
  AccountId: string;
  Amount: Long;
  Description: string;
}

export interface AdjustCreditsResponse {
  Account?: CreditAccountInfo | undefined;
}

function createBaseCreditAccountInfo(): CreditAccountInfo {
  return {
    AccountId: "",
    Balance: Long.ZERO,
    TotalEarned: Long.ZERO,
    TotalSpent: Long.ZERO,
    TotalPurchased: Long.ZERO,
    TokenEarnMultiplier: 0,
    UptimeEarnMultiplier: 0,
    DateCreated: undefined,
    DateLastUpdated: undefined,
  };
}

export const CreditAccountInfo: MessageFns<CreditAccountInfo> = {
  encode(message: CreditAccountInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (!message.Balance.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.Balance.toString());
    }
    if (!message.TotalEarned.equals(Long.ZERO)) {
      writer.uint32(24).int64(message.TotalEarned.toString());
    }
    if (!message.TotalSpent.equals(Long.ZERO)) {
      writer.uint32(32).int64(message.TotalSpent.toString());
    }
    if (!message.TotalPurchased.equals(Long.ZERO)) {
      writer.uint32(40).int64(message.TotalPurchased.toString());
    }
    if (message.TokenEarnMultiplier !== 0) {
      writer.uint32(49).double(message.TokenEarnMultiplier);
    }
    if (message.UptimeEarnMultiplier !== 0) {
      writer.uint32(57).double(message.UptimeEarnMultiplier);
    }
    if (message.DateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.DateCreated), writer.uint32(66).fork()).join();
    }
    if (message.DateLastUpdated !== undefined) {
      Timestamp.encode(toTimestamp(message.DateLastUpdated), writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditAccountInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreditAccountInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Balance = Long.fromString(reader.int64().toString());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.TotalEarned = Long.fromString(reader.int64().toString());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.TotalSpent = Long.fromString(reader.int64().toString());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.TotalPurchased = Long.fromString(reader.int64().toString());
          continue;
        }
        case 6: {
          if (tag !== 49) {
            break;
          }

          message.TokenEarnMultiplier = reader.double();
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.UptimeEarnMultiplier = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.DateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.DateLastUpdated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreditAccountInfo {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Balance: isSet(object.Balance) ? Long.fromValue(object.Balance) : Long.ZERO,
      TotalEarned: isSet(object.TotalEarned) ? Long.fromValue(object.TotalEarned) : Long.ZERO,
      TotalSpent: isSet(object.TotalSpent) ? Long.fromValue(object.TotalSpent) : Long.ZERO,
      TotalPurchased: isSet(object.TotalPurchased) ? Long.fromValue(object.TotalPurchased) : Long.ZERO,
      TokenEarnMultiplier: isSet(object.TokenEarnMultiplier) ? globalThis.Number(object.TokenEarnMultiplier) : 0,
      UptimeEarnMultiplier: isSet(object.UptimeEarnMultiplier) ? globalThis.Number(object.UptimeEarnMultiplier) : 0,
      DateCreated: isSet(object.DateCreated) ? fromJsonTimestamp(object.DateCreated) : undefined,
      DateLastUpdated: isSet(object.DateLastUpdated) ? fromJsonTimestamp(object.DateLastUpdated) : undefined,
    };
  },

  toJSON(message: CreditAccountInfo): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (!message.Balance.equals(Long.ZERO)) {
      obj.Balance = (message.Balance || Long.ZERO).toString();
    }
    if (!message.TotalEarned.equals(Long.ZERO)) {
      obj.TotalEarned = (message.TotalEarned || Long.ZERO).toString();
    }
    if (!message.TotalSpent.equals(Long.ZERO)) {
      obj.TotalSpent = (message.TotalSpent || Long.ZERO).toString();
    }
    if (!message.TotalPurchased.equals(Long.ZERO)) {
      obj.TotalPurchased = (message.TotalPurchased || Long.ZERO).toString();
    }
    if (message.TokenEarnMultiplier !== 0) {
      obj.TokenEarnMultiplier = message.TokenEarnMultiplier;
    }
    if (message.UptimeEarnMultiplier !== 0) {
      obj.UptimeEarnMultiplier = message.UptimeEarnMultiplier;
    }
    if (message.DateCreated !== undefined) {
      obj.DateCreated = message.DateCreated.toISOString();
    }
    if (message.DateLastUpdated !== undefined) {
      obj.DateLastUpdated = message.DateLastUpdated.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreditAccountInfo>, I>>(base?: I): CreditAccountInfo {
    return CreditAccountInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreditAccountInfo>, I>>(object: I): CreditAccountInfo {
    const message = createBaseCreditAccountInfo();
    message.AccountId = object.AccountId ?? "";
    message.Balance = (object.Balance !== undefined && object.Balance !== null)
      ? Long.fromValue(object.Balance)
      : Long.ZERO;
    message.TotalEarned = (object.TotalEarned !== undefined && object.TotalEarned !== null)
      ? Long.fromValue(object.TotalEarned)
      : Long.ZERO;
    message.TotalSpent = (object.TotalSpent !== undefined && object.TotalSpent !== null)
      ? Long.fromValue(object.TotalSpent)
      : Long.ZERO;
    message.TotalPurchased = (object.TotalPurchased !== undefined && object.TotalPurchased !== null)
      ? Long.fromValue(object.TotalPurchased)
      : Long.ZERO;
    message.TokenEarnMultiplier = object.TokenEarnMultiplier ?? 0;
    message.UptimeEarnMultiplier = object.UptimeEarnMultiplier ?? 0;
    message.DateCreated = object.DateCreated ?? undefined;
    message.DateLastUpdated = object.DateLastUpdated ?? undefined;
    return message;
  },
};

function createBaseCreditTransactionInfo(): CreditTransactionInfo {
  return {
    Id: "",
    AccountId: "",
    Type: "",
    Amount: Long.ZERO,
    Balance: Long.ZERO,
    Description: "",
    RelatedEntityId: "",
    Multiplier: 0,
    DateCreated: undefined,
  };
}

export const CreditTransactionInfo: MessageFns<CreditTransactionInfo> = {
  encode(message: CreditTransactionInfo, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Id !== "") {
      writer.uint32(10).string(message.Id);
    }
    if (message.AccountId !== "") {
      writer.uint32(18).string(message.AccountId);
    }
    if (message.Type !== "") {
      writer.uint32(26).string(message.Type);
    }
    if (!message.Amount.equals(Long.ZERO)) {
      writer.uint32(32).int64(message.Amount.toString());
    }
    if (!message.Balance.equals(Long.ZERO)) {
      writer.uint32(40).int64(message.Balance.toString());
    }
    if (message.Description !== "") {
      writer.uint32(50).string(message.Description);
    }
    if (message.RelatedEntityId !== "") {
      writer.uint32(58).string(message.RelatedEntityId);
    }
    if (message.Multiplier !== 0) {
      writer.uint32(65).double(message.Multiplier);
    }
    if (message.DateCreated !== undefined) {
      Timestamp.encode(toTimestamp(message.DateCreated), writer.uint32(74).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CreditTransactionInfo {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreditTransactionInfo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Type = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.Amount = Long.fromString(reader.int64().toString());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.Balance = Long.fromString(reader.int64().toString());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.Description = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.RelatedEntityId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.Multiplier = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.DateCreated = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CreditTransactionInfo {
    return {
      Id: isSet(object.Id) ? globalThis.String(object.Id) : "",
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Type: isSet(object.Type) ? globalThis.String(object.Type) : "",
      Amount: isSet(object.Amount) ? Long.fromValue(object.Amount) : Long.ZERO,
      Balance: isSet(object.Balance) ? Long.fromValue(object.Balance) : Long.ZERO,
      Description: isSet(object.Description) ? globalThis.String(object.Description) : "",
      RelatedEntityId: isSet(object.RelatedEntityId) ? globalThis.String(object.RelatedEntityId) : "",
      Multiplier: isSet(object.Multiplier) ? globalThis.Number(object.Multiplier) : 0,
      DateCreated: isSet(object.DateCreated) ? fromJsonTimestamp(object.DateCreated) : undefined,
    };
  },

  toJSON(message: CreditTransactionInfo): unknown {
    const obj: any = {};
    if (message.Id !== "") {
      obj.Id = message.Id;
    }
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.Type !== "") {
      obj.Type = message.Type;
    }
    if (!message.Amount.equals(Long.ZERO)) {
      obj.Amount = (message.Amount || Long.ZERO).toString();
    }
    if (!message.Balance.equals(Long.ZERO)) {
      obj.Balance = (message.Balance || Long.ZERO).toString();
    }
    if (message.Description !== "") {
      obj.Description = message.Description;
    }
    if (message.RelatedEntityId !== "") {
      obj.RelatedEntityId = message.RelatedEntityId;
    }
    if (message.Multiplier !== 0) {
      obj.Multiplier = message.Multiplier;
    }
    if (message.DateCreated !== undefined) {
      obj.DateCreated = message.DateCreated.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CreditTransactionInfo>, I>>(base?: I): CreditTransactionInfo {
    return CreditTransactionInfo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CreditTransactionInfo>, I>>(object: I): CreditTransactionInfo {
    const message = createBaseCreditTransactionInfo();
    message.Id = object.Id ?? "";
    message.AccountId = object.AccountId ?? "";
    message.Type = object.Type ?? "";
    message.Amount = (object.Amount !== undefined && object.Amount !== null)
      ? Long.fromValue(object.Amount)
      : Long.ZERO;
    message.Balance = (object.Balance !== undefined && object.Balance !== null)
      ? Long.fromValue(object.Balance)
      : Long.ZERO;
    message.Description = object.Description ?? "";
    message.RelatedEntityId = object.RelatedEntityId ?? "";
    message.Multiplier = object.Multiplier ?? 0;
    message.DateCreated = object.DateCreated ?? undefined;
    return message;
  },
};

function createBaseGetCreditAccountRequest(): GetCreditAccountRequest {
  return { AccountId: "" };
}

export const GetCreditAccountRequest: MessageFns<GetCreditAccountRequest> = {
  encode(message: GetCreditAccountRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCreditAccountRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCreditAccountRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCreditAccountRequest {
    return { AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "" };
  },

  toJSON(message: GetCreditAccountRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCreditAccountRequest>, I>>(base?: I): GetCreditAccountRequest {
    return GetCreditAccountRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCreditAccountRequest>, I>>(object: I): GetCreditAccountRequest {
    const message = createBaseGetCreditAccountRequest();
    message.AccountId = object.AccountId ?? "";
    return message;
  },
};

function createBaseGetCreditAccountResponse(): GetCreditAccountResponse {
  return { Account: undefined };
}

export const GetCreditAccountResponse: MessageFns<GetCreditAccountResponse> = {
  encode(message: GetCreditAccountResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Account !== undefined) {
      CreditAccountInfo.encode(message.Account, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCreditAccountResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCreditAccountResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Account = CreditAccountInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCreditAccountResponse {
    return { Account: isSet(object.Account) ? CreditAccountInfo.fromJSON(object.Account) : undefined };
  },

  toJSON(message: GetCreditAccountResponse): unknown {
    const obj: any = {};
    if (message.Account !== undefined) {
      obj.Account = CreditAccountInfo.toJSON(message.Account);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCreditAccountResponse>, I>>(base?: I): GetCreditAccountResponse {
    return GetCreditAccountResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCreditAccountResponse>, I>>(object: I): GetCreditAccountResponse {
    const message = createBaseGetCreditAccountResponse();
    message.Account = (object.Account !== undefined && object.Account !== null)
      ? CreditAccountInfo.fromPartial(object.Account)
      : undefined;
    return message;
  },
};

function createBaseGetCreditTransactionsRequest(): GetCreditTransactionsRequest {
  return { AccountId: "", PageSize: 0, PageIndex: 0 };
}

export const GetCreditTransactionsRequest: MessageFns<GetCreditTransactionsRequest> = {
  encode(message: GetCreditTransactionsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.PageSize !== 0) {
      writer.uint32(16).int32(message.PageSize);
    }
    if (message.PageIndex !== 0) {
      writer.uint32(24).int32(message.PageIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCreditTransactionsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCreditTransactionsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.PageSize = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.PageIndex = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCreditTransactionsRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      PageSize: isSet(object.PageSize) ? globalThis.Number(object.PageSize) : 0,
      PageIndex: isSet(object.PageIndex) ? globalThis.Number(object.PageIndex) : 0,
    };
  },

  toJSON(message: GetCreditTransactionsRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.PageSize !== 0) {
      obj.PageSize = Math.round(message.PageSize);
    }
    if (message.PageIndex !== 0) {
      obj.PageIndex = Math.round(message.PageIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCreditTransactionsRequest>, I>>(base?: I): GetCreditTransactionsRequest {
    return GetCreditTransactionsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCreditTransactionsRequest>, I>>(object: I): GetCreditTransactionsRequest {
    const message = createBaseGetCreditTransactionsRequest();
    message.AccountId = object.AccountId ?? "";
    message.PageSize = object.PageSize ?? 0;
    message.PageIndex = object.PageIndex ?? 0;
    return message;
  },
};

function createBaseGetCreditTransactionsResponse(): GetCreditTransactionsResponse {
  return { Transactions: [], TotalCount: 0 };
}

export const GetCreditTransactionsResponse: MessageFns<GetCreditTransactionsResponse> = {
  encode(message: GetCreditTransactionsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.Transactions) {
      CreditTransactionInfo.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.TotalCount !== 0) {
      writer.uint32(16).int32(message.TotalCount);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetCreditTransactionsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetCreditTransactionsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Transactions.push(CreditTransactionInfo.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.TotalCount = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetCreditTransactionsResponse {
    return {
      Transactions: globalThis.Array.isArray(object?.Transactions)
        ? object.Transactions.map((e: any) => CreditTransactionInfo.fromJSON(e))
        : [],
      TotalCount: isSet(object.TotalCount) ? globalThis.Number(object.TotalCount) : 0,
    };
  },

  toJSON(message: GetCreditTransactionsResponse): unknown {
    const obj: any = {};
    if (message.Transactions?.length) {
      obj.Transactions = message.Transactions.map((e) => CreditTransactionInfo.toJSON(e));
    }
    if (message.TotalCount !== 0) {
      obj.TotalCount = Math.round(message.TotalCount);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetCreditTransactionsResponse>, I>>(base?: I): GetCreditTransactionsResponse {
    return GetCreditTransactionsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetCreditTransactionsResponse>, I>>(
    object: I,
  ): GetCreditTransactionsResponse {
    const message = createBaseGetCreditTransactionsResponse();
    message.Transactions = object.Transactions?.map((e) => CreditTransactionInfo.fromPartial(e)) || [];
    message.TotalCount = object.TotalCount ?? 0;
    return message;
  },
};

function createBaseSetMultipliersRequest(): SetMultipliersRequest {
  return { AccountId: "", TokenEarnMultiplier: undefined, UptimeEarnMultiplier: undefined };
}

export const SetMultipliersRequest: MessageFns<SetMultipliersRequest> = {
  encode(message: SetMultipliersRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (message.TokenEarnMultiplier !== undefined) {
      writer.uint32(17).double(message.TokenEarnMultiplier);
    }
    if (message.UptimeEarnMultiplier !== undefined) {
      writer.uint32(25).double(message.UptimeEarnMultiplier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetMultipliersRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMultipliersRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 17) {
            break;
          }

          message.TokenEarnMultiplier = reader.double();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.UptimeEarnMultiplier = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMultipliersRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      TokenEarnMultiplier: isSet(object.TokenEarnMultiplier)
        ? globalThis.Number(object.TokenEarnMultiplier)
        : undefined,
      UptimeEarnMultiplier: isSet(object.UptimeEarnMultiplier)
        ? globalThis.Number(object.UptimeEarnMultiplier)
        : undefined,
    };
  },

  toJSON(message: SetMultipliersRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (message.TokenEarnMultiplier !== undefined) {
      obj.TokenEarnMultiplier = message.TokenEarnMultiplier;
    }
    if (message.UptimeEarnMultiplier !== undefined) {
      obj.UptimeEarnMultiplier = message.UptimeEarnMultiplier;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMultipliersRequest>, I>>(base?: I): SetMultipliersRequest {
    return SetMultipliersRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMultipliersRequest>, I>>(object: I): SetMultipliersRequest {
    const message = createBaseSetMultipliersRequest();
    message.AccountId = object.AccountId ?? "";
    message.TokenEarnMultiplier = object.TokenEarnMultiplier ?? undefined;
    message.UptimeEarnMultiplier = object.UptimeEarnMultiplier ?? undefined;
    return message;
  },
};

function createBaseSetMultipliersResponse(): SetMultipliersResponse {
  return { Account: undefined };
}

export const SetMultipliersResponse: MessageFns<SetMultipliersResponse> = {
  encode(message: SetMultipliersResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Account !== undefined) {
      CreditAccountInfo.encode(message.Account, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetMultipliersResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetMultipliersResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Account = CreditAccountInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetMultipliersResponse {
    return { Account: isSet(object.Account) ? CreditAccountInfo.fromJSON(object.Account) : undefined };
  },

  toJSON(message: SetMultipliersResponse): unknown {
    const obj: any = {};
    if (message.Account !== undefined) {
      obj.Account = CreditAccountInfo.toJSON(message.Account);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetMultipliersResponse>, I>>(base?: I): SetMultipliersResponse {
    return SetMultipliersResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetMultipliersResponse>, I>>(object: I): SetMultipliersResponse {
    const message = createBaseSetMultipliersResponse();
    message.Account = (object.Account !== undefined && object.Account !== null)
      ? CreditAccountInfo.fromPartial(object.Account)
      : undefined;
    return message;
  },
};

function createBasePurchaseCreditsRequest(): PurchaseCreditsRequest {
  return { AccountId: "", Amount: Long.ZERO, Description: "" };
}

export const PurchaseCreditsRequest: MessageFns<PurchaseCreditsRequest> = {
  encode(message: PurchaseCreditsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (!message.Amount.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.Amount.toString());
    }
    if (message.Description !== "") {
      writer.uint32(26).string(message.Description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PurchaseCreditsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePurchaseCreditsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Amount = Long.fromString(reader.int64().toString());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PurchaseCreditsRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Amount: isSet(object.Amount) ? Long.fromValue(object.Amount) : Long.ZERO,
      Description: isSet(object.Description) ? globalThis.String(object.Description) : "",
    };
  },

  toJSON(message: PurchaseCreditsRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (!message.Amount.equals(Long.ZERO)) {
      obj.Amount = (message.Amount || Long.ZERO).toString();
    }
    if (message.Description !== "") {
      obj.Description = message.Description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PurchaseCreditsRequest>, I>>(base?: I): PurchaseCreditsRequest {
    return PurchaseCreditsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PurchaseCreditsRequest>, I>>(object: I): PurchaseCreditsRequest {
    const message = createBasePurchaseCreditsRequest();
    message.AccountId = object.AccountId ?? "";
    message.Amount = (object.Amount !== undefined && object.Amount !== null)
      ? Long.fromValue(object.Amount)
      : Long.ZERO;
    message.Description = object.Description ?? "";
    return message;
  },
};

function createBasePurchaseCreditsResponse(): PurchaseCreditsResponse {
  return { Account: undefined };
}

export const PurchaseCreditsResponse: MessageFns<PurchaseCreditsResponse> = {
  encode(message: PurchaseCreditsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Account !== undefined) {
      CreditAccountInfo.encode(message.Account, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PurchaseCreditsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePurchaseCreditsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Account = CreditAccountInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PurchaseCreditsResponse {
    return { Account: isSet(object.Account) ? CreditAccountInfo.fromJSON(object.Account) : undefined };
  },

  toJSON(message: PurchaseCreditsResponse): unknown {
    const obj: any = {};
    if (message.Account !== undefined) {
      obj.Account = CreditAccountInfo.toJSON(message.Account);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PurchaseCreditsResponse>, I>>(base?: I): PurchaseCreditsResponse {
    return PurchaseCreditsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PurchaseCreditsResponse>, I>>(object: I): PurchaseCreditsResponse {
    const message = createBasePurchaseCreditsResponse();
    message.Account = (object.Account !== undefined && object.Account !== null)
      ? CreditAccountInfo.fromPartial(object.Account)
      : undefined;
    return message;
  },
};

function createBaseAdjustCreditsRequest(): AdjustCreditsRequest {
  return { AccountId: "", Amount: Long.ZERO, Description: "" };
}

export const AdjustCreditsRequest: MessageFns<AdjustCreditsRequest> = {
  encode(message: AdjustCreditsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.AccountId !== "") {
      writer.uint32(10).string(message.AccountId);
    }
    if (!message.Amount.equals(Long.ZERO)) {
      writer.uint32(16).int64(message.Amount.toString());
    }
    if (message.Description !== "") {
      writer.uint32(26).string(message.Description);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdjustCreditsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdjustCreditsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.AccountId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.Amount = Long.fromString(reader.int64().toString());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.Description = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdjustCreditsRequest {
    return {
      AccountId: isSet(object.AccountId) ? globalThis.String(object.AccountId) : "",
      Amount: isSet(object.Amount) ? Long.fromValue(object.Amount) : Long.ZERO,
      Description: isSet(object.Description) ? globalThis.String(object.Description) : "",
    };
  },

  toJSON(message: AdjustCreditsRequest): unknown {
    const obj: any = {};
    if (message.AccountId !== "") {
      obj.AccountId = message.AccountId;
    }
    if (!message.Amount.equals(Long.ZERO)) {
      obj.Amount = (message.Amount || Long.ZERO).toString();
    }
    if (message.Description !== "") {
      obj.Description = message.Description;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdjustCreditsRequest>, I>>(base?: I): AdjustCreditsRequest {
    return AdjustCreditsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdjustCreditsRequest>, I>>(object: I): AdjustCreditsRequest {
    const message = createBaseAdjustCreditsRequest();
    message.AccountId = object.AccountId ?? "";
    message.Amount = (object.Amount !== undefined && object.Amount !== null)
      ? Long.fromValue(object.Amount)
      : Long.ZERO;
    message.Description = object.Description ?? "";
    return message;
  },
};

function createBaseAdjustCreditsResponse(): AdjustCreditsResponse {
  return { Account: undefined };
}

export const AdjustCreditsResponse: MessageFns<AdjustCreditsResponse> = {
  encode(message: AdjustCreditsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.Account !== undefined) {
      CreditAccountInfo.encode(message.Account, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdjustCreditsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdjustCreditsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.Account = CreditAccountInfo.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdjustCreditsResponse {
    return { Account: isSet(object.Account) ? CreditAccountInfo.fromJSON(object.Account) : undefined };
  },

  toJSON(message: AdjustCreditsResponse): unknown {
    const obj: any = {};
    if (message.Account !== undefined) {
      obj.Account = CreditAccountInfo.toJSON(message.Account);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdjustCreditsResponse>, I>>(base?: I): AdjustCreditsResponse {
    return AdjustCreditsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdjustCreditsResponse>, I>>(object: I): AdjustCreditsResponse {
    const message = createBaseAdjustCreditsResponse();
    message.Account = (object.Account !== undefined && object.Account !== null)
      ? CreditAccountInfo.fromPartial(object.Account)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Long ? string | number | Long : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = numberToLong(Math.trunc(date.getTime() / 1_000));
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds.toNumber() || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function numberToLong(number: number) {
  return Long.fromNumber(number);
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
